import React, { useState, useEffect } from "react";
import AtDropdown from "../AtDropdown";
import { EditableText, H3, H5, Toast, Toaster } from "@blueprintjs/core";
import {
  designDetailActions,
  useDesignDetailState,
  useDispatchDesignDetail
} from "../../../reducers/designdetails.reducer";
import strings from "../../../strings";
import {
  getcurrentCollectionFilter,
  getWidthOptions,
  hasWidthFilter
} from "../../../utils/treeutils";
import {
  calculateTotalArea,
  convertFeetInchToNumber,
  convertNumberToFeetInch,
  convertUnit_Arr,
  displayAreaInFt,
  displayAreaOfRug
} from "../../../utils/utils";
import { getDefaultValueOfField } from "../../../middleware/ordersheet.middleware";
import { useDesignListState } from "../../../reducers/designlist.reducer";
import { usePriceCalculator } from "../../../hooks";
import AtButton from "../AtButton";
import Divider from "../Divider";
import { useOrdersheetDetailState } from "../../../reducers/ordersheetdetails.reducer";

function UnitConverter({
  originalName,
  orderSheetDetails,
  setOrderSheetDetails,
  props,
  showRugSize,
  formFields,
  setFormFields,
  widthOptions,
  englishVillageLane,
  selectedWidOption,
  handleWidthOptionChange,
  rugsizeUpdated,
  setRugsizeUpdated
}) {
  const { handleShapeChange = false } = props;
  const designDetailState = useDesignDetailState();
  const ordersheetDetailState = useOrdersheetDetailState();

  const {
    designDetails,

    customFields: csfields
  } = designDetailState;
  const state = useDesignListState();
  const customFields = csfields.fields;
  const { flags } = window;
  const { colorSelectionBox: CsbFlags, ordersheet: ordersheetFlags } = window.flags;
  const { collectionFilter } = CsbFlags;
  var { fullpath } = designDetailState;
  const dispatchDesignDetails = useDispatchDesignDetail();
  const { defaultQualityIndex } = flags;
  const rugQualities = window.InterfaceElements.AvailableQualities;
  const { setCustomConversion = false, customInToCmFactor } = ordersheetFlags.customConversion;
  const showPrice = window.InterfaceElements.ShowPrice && !window.initialData.customDesignUrl;

  const [displayMaxErrorMessage, setDisplayMaxErrorMessage] = useState("");
  const [selectedKnot, setSelectedKnot] = useState([0]);
  const [toastProps, setToastProps] = useState(false);

  const units = [
    { val: "ft", text: strings.ordersheet.orderUnits.ft },
    { val: "cm", text: strings.ordersheet.orderUnits.cm }
  ];

  const price = usePriceCalculator({
    designDetails: orderSheetDetails,
    fullpath,
    showPrice
  });

  const allowResizeForSelectedRug = () => {
    var showRugSize = true;
    if (originalName && ordersheetFlags.designsToHideRugSizeFor.length) {
      showRugSize =
        ordersheetFlags.designsToHideRugSizeFor.indexOf(originalName) >= 0 ? false : true;
    }
    return showRugSize;
  };

  const isWidHgtEqual = () => {
    if (!ordersheetFlags.sameWidNHgt) return false;
    if (!designDetails.PhysicalWidth || !designDetails.PhysicalHeight) {
      return false;
    }
    return designDetails.PhysicalWidth.toFixed(1) === designDetails.PhysicalHeight.toFixed(1);
  };

  const updateOrdersheetDetails = () => {
    let det;
    if (window.flags.showOrdersheetOutside && orderSheetDetails.PhysicalWidth) {
      // when autocolor resets the ordersheet input value. Hence, set orderproperties, size and carving again
      let PhysicalHeight = orderSheetDetails.PhysicalHeight || designDetails.PhysicalHeight;
      let PhysicalWidth = orderSheetDetails.PhysicalWidth || designDetails.PhysicalWidth;
      let Unit = orderSheetDetails.Unit || designDetails.Unit;
      let Carving = orderSheetDetails.Carving || designDetails.Carving;
      let OrderProperties = orderSheetDetails.OrderProperties || designDetails.OrderProperties;

      PhysicalWidth = getSelectedWidOption(PhysicalWidth, Unit);

      det = {
        ...orderSheetDetails,
        ...designDetails,
        PhysicalHeight,
        PhysicalWidth,
        Unit,
        Carving,
        OrderProperties
      };
    } else {
      let PhysicalHeight = orderSheetDetails.PhysicalHeight || designDetails.PhysicalHeight;
      let PhysicalWidth = orderSheetDetails.PhysicalWidth || designDetails.PhysicalWidth;
      let Unit = orderSheetDetails.Unit || designDetails.Unit;
      PhysicalWidth = getSelectedWidOption(PhysicalWidth, Unit);

      det = { ...orderSheetDetails, ...designDetails, PhysicalWidth, PhysicalHeight, Unit };
    }
    setOrderSheetDetails(det);
  };

  useEffect(() => {
    //for when area of rug is changed, the value in ordersheet must also change. When "changeActualRugSize" flag is true.
    if (!orderSheetDetails.PhysicalWidth || !orderSheetDetails.PhysicalHeight) return;
    const PhysicalWidth = designDetails.PhysicalWidth;
    const PhysicalHeight = designDetails.PhysicalHeight;
    const Unit = designDetails.Unit;
    var det = { ...orderSheetDetails, ...designDetails, PhysicalWidth, PhysicalHeight, Unit };
    if (ordersheetFlags.specificKnotForSpecificFolder.length != 0) {
      const specificKnotArrayForSpecificFolder = ordersheetFlags.specificKnotForSpecificFolder;
      specificKnotArrayForSpecificFolder.map(item => {
        if (state.selectedFile.location.includes(item[0])) {
          det = {
            ...det,
            OrderProperties: { ...orderSheetDetails.OrderProperties, QualityIndex: item[1][0] }
          };
          setSelectedKnot(item[1]);
        }
      });
    }
    setOrderSheetDetails(det);
  }, [designDetails.PhysicalWidth, designDetails.PhysicalHeight, state.selectedFile]);

  const handleUnitChange = Unit => {
    const [PhysicalWidth, PhysicalHeight] = convertUnit_Arr(
      orderSheetDetails.Unit,
      Unit,
      [orderSheetDetails.PhysicalWidth, orderSheetDetails.PhysicalHeight],
      setCustomConversion,
      customInToCmFactor
    );
    setOrderSheetDetails({ ...orderSheetDetails, PhysicalHeight, PhysicalWidth, Unit });
  };

  const getSelectedWidOption = (PhysicalWidth, Unit) => {
    const widthOpt = getWidthOptions(collectionFilter, fullpath);
    if (widthOpt && widthOpt.length && selectedWidOption !== -1) {
      const value = widthOpt[selectedWidOption];
      PhysicalWidth = convertFeetInchToNumber(value, Unit);
    }
    return PhysicalWidth;
  };

  useEffect(() => {
    updateOrdersheetDetails();
  }, [designDetails]);

  const handleShapeOptionChange = i => {
    const fieldId = ordersheetFlags.hasShapeOptions.customFieldId;
    const selectedShapeValue = ordersheetFlags.hasShapeOptions.options[i];

    let fields = formFields.fields.map(field => {
      let fieldVal = field.fieldValue;
      if (field.fieldName.toLowerCase() === fieldId.toLowerCase()) {
        fieldVal = selectedShapeValue;
        return {
          fieldName: field.fieldName,
          fieldValue: fieldVal
        };
      } else {
        return {
          fieldName: field.fieldName,
          fieldValue: field.fieldValue
        };
      }
    });

    setFormFields({ ...formFields, fields });
    updateOrdersheetDetails();
    if (handleShapeChange) handleShapeChange(i);
  };
  const handleQualityChange = i => {
    setOrderSheetDetails({
      ...orderSheetDetails,
      OrderProperties: { ...orderSheetDetails.OrderProperties, QualityIndex: i }
    });
  };

  const _displayAreaOfRug = () => {
    return displayAreaOfRug(orderSheetDetails);
  };
  const displayUnitOfRug = () => {
    let displayUnit = orderSheetDetails.Unit;
    if (orderSheetDetails.Unit === "cm") displayUnit = "m";
    return displayUnit;
  };
  const pricePerUnit = () => {
    let priceStr = "";
    if (_displayAreaOfRug() > 0) {
      priceStr = `(${price.Currency}${(parseFloat(price.Value) / _displayAreaOfRug()).toFixed(
        2
      )}/ sq. ${displayUnitOfRug()})`;
    }
    return priceStr;
  };
  const rugQuality = () => {
    //TODO:implement rugqualities
    const { Width, Height, PhysicalWidth, PhysicalHeight, Unit } = designDetails;
    const [newwidth, newheight] = convertUnit_Arr(
      Unit,
      "cm",
      [PhysicalWidth, PhysicalHeight],
      setCustomConversion,
      customInToCmFactor
    );
    const knots = Math.round((Width / newwidth) * 10);
    const lines = Math.round((Height / newheight) * 10);
    const qualwithdist = ordersheetFlags.customRugQualities.map(item => ({
      ...item,
      distance: Math.sqrt(Math.pow(item.knots - knots, 2) + Math.pow(lines - item.lines, 2))
    }));
    const mindistqual = qualwithdist.reduce(
      (min, p) => (p.distance < min.distance ? p : min),
      qualwithdist[0]
    );
    return mindistqual ? mindistqual.quality : "";
  };

  const handleRugPhysicalSizeChange = () => {
    var height = parseFloat(orderSheetDetails.PhysicalHeight);
    var width = parseFloat(orderSheetDetails.PhysicalWidth);
    var unit = orderSheetDetails.Unit;

    dispatchDesignDetails({
      type: designDetailActions.SET_RUG_PHYSICAL_SIZE,
      payload: {
        PhysicalHeight: height,
        PhysicalWidth: width,
        Unit: unit
      }
    });
  };
  const handleWidthInputChange = PhysicalWidth => {
    if (PhysicalWidth && parseFloat(PhysicalWidth)) {
      setRugsizeUpdated({ ...rugsizeUpdated, w: true });

      let PhysicalHeight = orderSheetDetails.PhysicalHeight;
      if (isWidHgtEqual()) {
        PhysicalHeight = PhysicalWidth;
      }
      setOrderSheetDetails({
        ...orderSheetDetails,
        PhysicalWidth,
        PhysicalHeight
      });
    } else {
      setRugsizeUpdated({ ...rugsizeUpdated, w: false });
    }
  };
  const handleHeightInputChange = PhysicalHeight => {
    if (PhysicalHeight && parseFloat(PhysicalHeight)) {
      setRugsizeUpdated({ ...rugsizeUpdated, h: true });

      let PhysicalWidth = orderSheetDetails.PhysicalWidth;
      if (isWidHgtEqual()) {
        PhysicalWidth = PhysicalHeight;
      }
      setOrderSheetDetails({
        ...orderSheetDetails,
        PhysicalWidth,
        PhysicalHeight
      });
    } else {
      setRugsizeUpdated({ ...rugsizeUpdated, h: false });
    }
  };

  return (
    <>
      {showPrice && parseFloat(price.Value) > 0 && (
        <div className="at-ordersheet-price-area">
          {price.Value.lastIndexOf("%") >= 0 ? (
            <>
              <H3>
                {/* ${price.Value} ${flags.ordersheet.strInPrice} */}
                {window.flags.accountSpecific.isEnglishVillageLane
                  ? englishVillageLane.totalRugPadPrice
                  : price.Value}{" "}
                ${flags.ordersheet.strInPrice}
              </H3>
            </>
          ) : (
            <>
              <H3>
                {/* {price.Currency}{parseFloat(price.Value)} */}
                {price.Currency}
                {window.flags.accountSpecific.isEnglishVillageLane
                  ? englishVillageLane.totalRugPadPrice
                  : parseFloat(price.Value)}
              </H3>
              <H5 className="at-ordersheet-pua">
                {" "}
                {window.flags.accountSpecific.isEnglishVillageLane
                  ? englishVillageLane.rugPadPrice
                  : pricePerUnit()}
              </H5>
            </>
          )}
        </div>
      )}
      <div
        className={
          ordersheetFlags.changeActualRugSize && allowResizeForSelectedRug()
            ? "at-ordersheet-rugresize-area"
            : "at-ordersheet-dims-area"
        }
      >
        <div
          className="at-units-input at-units-input-field"
          id={
            ordersheetFlags.changeActualRugSize && allowResizeForSelectedRug()
              ? "at-ordersheet-rugResize-input-width"
              : "at-ordersheet-input-width"
          }
        >
          <p>{`${strings.ordersheet.width} ${ordersheetFlags.isRugsizeMandatory ? "*" : ""}`}</p>

          {hasWidthFilter(collectionFilter) ? (
            <AtDropdown
              dropdownItems={widthOptions}
              defaultItemIndex={selectedWidOption}
              onChange={i => handleWidthOptionChange(i, orderSheetDetails, widthOptions)}
              addPlaceholder={window.flags.colorSelectionBox.addPlaceholderinWidthOptions}
              placeholderText={window.flags.colorSelectionBox.placeholderTextinWidthOptions}
            />
          ) : (
            <EditableOrdersheetField
              value={
                showRugSize
                  ? orderSheetDetails.Unit == "cm"
                    ? Math.round(orderSheetDetails.PhysicalWidth)
                    : orderSheetDetails.PhysicalWidth
                  : ""
              }
              unit={orderSheetDetails.Unit}
              handleConfirm={PhysicalWidth => {
                handleWidthInputChange(PhysicalWidth);
              }}
            />
          )}
        </div>
        <div
          className="at-units-input at-units-input-field"
          id={
            ordersheetFlags.changeActualRugSize && allowResizeForSelectedRug()
              ? "at-ordersheet-rugResize-input-height"
              : "at-ordersheet-input-height"
          }
        >
          <p>{`${strings.ordersheet.height} ${ordersheetFlags.isRugsizeMandatory ? "*" : ""}`}</p>

          <EditableOrdersheetField
            value={
              showRugSize
                ? orderSheetDetails.Unit == "cm"
                  ? Math.round(orderSheetDetails.PhysicalHeight)
                  : orderSheetDetails.PhysicalHeight
                : ""
            }
            unit={orderSheetDetails.Unit}
            handleConfirm={PhysicalHeight => {
              handleHeightInputChange(PhysicalHeight);
            }}
          />
        </div>
        <div className="at-units-input at-units-input-dropdown" id="at-ordersheet-input-unit">
          <p>{strings.ordersheet.unit}</p>
          {flags.ordersheet.changeableUnits ? (
            <AtDropdown
              dropdownItems={units.map(item => item.text)}
              defaultItemIndex={units.findIndex(item => item.val === orderSheetDetails.Unit)}
              onChange={i => handleUnitChange(units[i].val)}
            />
          ) : (
            <div className="at-units-input__unit">
              {units.find(item => item.val === flags.defaultUnit).text}
            </div>
          )}
        </div>

        <div
          className={`at-units-input at-units-input-dropdown ${
            ordersheetDetailState.accountSpecific.davisRugs.rugTechnique != "CYP Tuft" &&
            flags.accountSpecific.priceEstimation_davisLandings.checkKeyForPrice
              ? "at-ordersheet-input-quality-davis"
              : ""
          }`}
          id="at-ordersheet-input-quality"
        >
          <p>{strings.ordersheet.quality}</p>
          {(() => {
            if (ordersheetFlags.customRugQualities.length) {
              return <p className="at-units-input__qualitytext">{rugQuality()}</p>;
            } else if (ordersheetFlags.specificKnotForSpecificFolder.length != 0) {
              return (
                <>
                  {state.selectedFile && (
                    <>
                      {selectedKnot.length == 1 ? (
                        <p id="selectedKnotText">
                          {window.InterfaceElements.AvailableQualities[selectedKnot]}
                        </p>
                      ) : (
                        <AtDropdown
                          dropdownItems={window.InterfaceElements.AvailableQualities.filter(
                            (x, index) => selectedKnot.includes(index)
                          )}
                          onChange={i => handleQualityChange(selectedKnot[i])}
                          defaultItemIndex={selectedKnot.indexOf(
                            orderSheetDetails.OrderProperties !== undefined
                              ? orderSheetDetails.OrderProperties.QualityIndex
                              : defaultQualityIndex
                          )}
                        />
                      )}
                    </>
                  )}
                </>
              );
            } else {
              return (
                <AtDropdown
                  dropdownItems={rugQualities}
                  onChange={handleQualityChange}
                  defaultItemIndex={
                    orderSheetDetails.OrderProperties !== undefined
                      ? orderSheetDetails.OrderProperties.QualityIndex
                      : defaultQualityIndex
                  }
                />
              );
            }
          })()}
        </div>

        {ordersheetFlags.hasShapeOptions &&
          ordersheetFlags.hasShapeOptions.options &&
          ordersheetFlags.hasShapeOptions.options.length && (
            <div className="at-units-input at-units-input-dropdown" id="at-ordersheet-input-shape">
              <p>{strings.ordersheet.shape}</p>
              <AtDropdown
                dropdownItems={ordersheetFlags.hasShapeOptions.options}
                onChange={handleShapeOptionChange}
                defaultItemIndex={ordersheetFlags.hasShapeOptions.defaultOptionIndex}
              />
            </div>
          )}

        {ordersheetFlags.changeActualRugSize && allowResizeForSelectedRug() && (
          <>
            <AtButton
              id="rugresize__apply"
              intent="primary"
              tertiary
              onClick={handleRugPhysicalSizeChange}
              text={strings.tools.apply}
            />
            <Divider className="at-ordersheet-divider-rugresize" horizontal />
          </>
        )}
      </div>
      {flags.ordersheet.showRugSizeInOrderForm ? (
        <div className="at-ordersheet-dims-totalarea">
          {strings.ordersheet.totalArea} :{" "}
          {_displayAreaOfRug() > 0 &&
            (flags.ordersheet.populateRugSize ||
              showRugSize ||
              (rugsizeUpdated.w && rugsizeUpdated.h)) && (
              <span
                className="at-ordersheet-dims-totalarea__value"
                dangerouslySetInnerHTML={{
                  __html: calculateTotalArea(orderSheetDetails)
                }}
              ></span>
            )}
          {ordersheetFlags.hasMinAreaCriteria > 0 &&
            displayAreaInFt(orderSheetDetails, setCustomConversion, customInToCmFactor) <=
              ordersheetFlags.hasMinAreaCriteria && (
              <div className="at-ordersheet-area-message">{ordersheetFlags.minAreaCriteriaMsg}</div>
            )}
          {(ordersheetFlags.maxWidth != null || ordersheetFlags.maxLength != null) &&
            displayMaxErrorMessage && (
              <div className="at-ordersheet-max-area-message">
                <Toaster position="top-right">
                  {toastProps && (
                    <Toast
                      message={displayMaxErrorMessage}
                      intent="danger"
                      onDismiss={() => setToastProps(false)}
                    />
                  )}
                </Toaster>
              </div>
            )}
        </div>
      ) : null}
    </>
  );
}

const EditableOrdersheetField = props => {
  const { value, unit, handleConfirm } = props;

  const [valueAsString, setValueAsString] = useState(null);
  const [changeState, setChangeState] = useState(false);
  useEffect(() => {
    value === "" ? setValueAsString("") : setValueAsString(convertNumberToFeetInch(value, unit));
  }, [value, unit, changeState]);

  return (
    <EditableText
      selectAllOnFocus
      value={valueAsString}
      onChange={setValueAsString}
      onConfirm={val => {
        if (window.flags.ordersheet.showDoubleBoxForFtInch) {
          setChangeState(!changeState); //done to reload state
        }
        const n = convertFeetInchToNumber(val, unit);
        if (handleConfirm) handleConfirm(n);
      }}
    ></EditableText>
  );
};
export default UnitConverter;
